import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Box,
} from '@mui/material';
import dayjs from 'dayjs';

export default function EmailDetailsDialog({
  open,
  onClose,
  title,
  opensDetail = [],
  clicksDetail = [],
  metaData = null,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {opensDetail.length > 0 && (
          <Box mb={3}>
            <Typography variant="h6">Opens Details</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Timestamp</TableCell>
                  <TableCell>Location</TableCell>
                  <TableCell>User Agent</TableCell>
                  <TableCell>IP</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {opensDetail.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{dayjs.unix(row.ts).format('MMM D, YYYY HH:mm:ss')}</TableCell>
                    <TableCell>{row.location || '-'}</TableCell>
                    <TableCell>{row.ua || '-'}</TableCell>
                    <TableCell>{row.ip || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
        {clicksDetail.length > 0 && (
          <Box mb={3}>
            <Typography variant="h6">Clicks Details</Typography>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Timestamp</TableCell>
                  <TableCell>URL</TableCell>
                  <TableCell>Location</TableCell>
                  <TableCell>User Agent</TableCell>
                  <TableCell>IP</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clicksDetail.map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{dayjs.unix(row.ts).format('MMM D, YYYY HH:mm:ss')}</TableCell>
                    <TableCell>
                      <a href={row.url} target="_blank" rel="noopener noreferrer">
                        {row.url || '-'}
                      </a>
                    </TableCell>
                    <TableCell>{row.location || '-'}</TableCell>
                    <TableCell>{row.ua || '-'}</TableCell>
                    <TableCell>{row.ip || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
        {metaData && Object.keys(metaData).length > 0 && (
          <Box mb={3}>
            <Typography variant="h6">Metadata</Typography>
            <Table size="small">
              <TableBody>
                {Object.entries(metaData).map(([key, value]) => (
                  <TableRow key={key}>
                    <TableCell sx={{ fontWeight: 'bold', textTransform: 'capitalize' }}>
                      {key.replace(/_/g, ' ')}
                    </TableCell>
                    <TableCell>{value?.toString() || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
        {opensDetail.length === 0 && clicksDetail.length === 0 && (!metaData || Object.keys(metaData).length === 0) && (
          <Box mb={3}>
            <Typography color="text.secondary">No extra info found for this email.</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
